import React from 'react';

export const FeedContext = React.createContext(null);

export default FeedContext;
